import { useTheme } from '@mui/material/styles';

const useFormStyles = () => {
    const theme = useTheme();
    return {
        formLabel: {
            color:"#252836",
            textAlign: "left",
            fontWeight: "500",
            fontFamily: theme?.font?.fontFamily?.primary || "",
        }
    }
};

export default useFormStyles;